
import { mapState, mapMutations } from "vuex";
import _ from "underscore";
import uiPageHeader from "./components/ui-page-header";
import dayjs from "dayjs";
import { getCrashHistory } from "@/api";
import historyGameColor from "../util/historyGameColor";
import { VueEllipsis } from 'vue-ellipsis-component';


// game.crashPoint
export default {
	name: 'history',

	components: {
		"ui-page-header": uiPageHeader,
		VueEllipsis,
	},

	filters: {

	},


	data() {
		return {
			list: []
		};
	},
	watch: {
	},
	computed: {
		...mapState(["user"]),
		currencyType() {
			return Number(this.$route.meta?.currencyType ?? this.$route.query.currencyType ?? 0);
		},
		crashHistoryDetailRouteName() {
			if (this.currencyType === 1) return 'happyCoinCrashHistoryDetail';
			if (this.currencyType === 2) return 'coin1CrashHistoryDetail';
			return 'crashHistoryDetail';
		},
	},
	created() {
		this.fetchCrashHistory()
	},
	mounted() {

	},




	beforeDestroy() {
		// clearInterval(this.intervalId);
	},

	methods: {

		...mapMutations([""]),
		dayjs,
		async fetchCrashHistory() {
			try {
			const data = await getCrashHistory({ pageIndex: 0, pageSize: 100, currencyType: this.currencyType });
				console.log(data);
				this.list = data?.data?.data

			} catch (error) {
				console.log("There was an error while loading crash schema:", error);
			}
		},
		historyGameColor

	}
}
